import { AuthStore } from './auth.store';

/**
 * Composition root for MobX stores. v1 only owns the auth store —
 * future tickets attach orders / users / inspectors / etc. as
 * additional fields here.
 */
export class RootStore {
  auth: AuthStore;

  constructor() {
    this.auth = new AuthStore();
  }

  dispose(): void {
    this.auth.dispose();
  }
}

export const createRootStore = (): RootStore => new RootStore();
